<template>
    <rkm-form
        ref="Form"
    >
        <rkm-col>
            <rkm-area
                v-for="consumo in geral"
                v-bind:key="consumo.id"
                :title="`${consumo.pergunta} ${shouldBeRequired(consumo) ? '*' : ''}`"
                type="section"
                :class="{ 'no-margin-top': consumo.id === geral[0].id }"
            >
                <div v-if="consumo.respostas">
                    <div v-if="consumo.multipla">
                        <rkm-form-checkbox
                            v-for="(resposta, index) in consumo.respostas"
                            v-bind:key="index"
                            :value="resposta"
                            :name="`${consumo.pergunta}`"
                            :validations="validations.perguntaMultipla"
                            v-model="model.perguntaMultipla"
                            inline
                            :disabled="readonly"
                        >
                            {{ resposta }}
                        </rkm-form-checkbox>
                    </div>
                    <div v-else>
                        <rkm-form-radio-group
                            v-model="model.perguntaUnica[consumo.id]"
                            :name="`${consumo.pergunta}`"
                            ref="perguntaUnica"
                            :validations="!isPerguntaVisivel(consumo) ? [] : validations.perguntaUnica"
                        >
                            <rkm-form-radio
                                v-for="(resposta, index) in consumo.respostas"
                                v-bind:key="index"
                                :value="resposta"
                                inline
                                :disabled="!isPerguntaVisivel(consumo)"
                            >
                                {{ resposta }}
                         
                            </rkm-form-radio>
                        </rkm-form-radio-group>
                    </div>
                </div>
            </rkm-area>
        </rkm-col>

        <rkm-col class="mt-3">
            <rkm-area
                type="fieldset"
                :title="titulo"
            >
                <rkm-area
                    v-for="consumo in area"
                    v-bind:key="consumo.id"
                    :title="`${consumo.pergunta} ${shouldBeRequired(consumo) ? '*' : ''}`"
                    type="section"
                    :class="{ 'no-margin-top': consumo.id === area[0].id }"
                >
                    <div v-if="consumo.respostas">
                        <div v-if="consumo.multipla">
                            <rkm-form-checkbox
                                v-for="(resposta, index) in consumo.respostas"
                                v-bind:key="index"
                                :value="resposta"
                                :name="`${consumo.pergunta}`"
                                :validations="validations.perguntaMultipla"
                                v-model="model.perguntaMultipla"
                                :disabled="readonly"
                                inline
                            >
                                {{ resposta }}
                            </rkm-form-checkbox>
                        </div>
                        <div v-else>
                            <rkm-form-radio-group
                                v-model="model.perguntaUnica[consumo.id]"
                                :name="`${consumo.pergunta}`"
                                ref="perguntaUnica"
                                :validations="!isPerguntaVisivel(consumo) ? [] : validations.perguntaUnica"
                            >
                                <rkm-form-radio
                                    v-for="(resposta, index) in consumo.respostas"
                                    v-bind:key="index"
                                    :value="resposta"
                                    :disabled="!isPerguntaVisivel(consumo)"
                                    inline
                                >
                                    {{ resposta }}
                                </rkm-form-radio>
                            </rkm-form-radio-group>
                        </div>
                    </div>
                </rkm-area>
            </rkm-area>
        </rkm-col>
    </rkm-form>
</template>

<script>

export default ({
    name: 'Questionario',
    props: {
        questionario: {
            type: Array,
            required: true,
            default: null
        },
        titulo: { type: String },
        required: { type: Boolean, default: true },
        readonly: { type: Boolean, default: false },

    },
    data: () => ({
        disableRadio:false,
        localRequired: true,
        model: {
            perguntaMultipla: [],
            perguntaUnica: [],
            perguntaDependente:[]
        },
    }),

    methods: {
        shouldBeRequired(consumo) {
            if (consumo.perguntaPaiId) {
                const respostaPerguntaPai = this.model.perguntaUnica[consumo.perguntaPaiId];
                return respostaPerguntaPai === 'Sim';
            }
            return false;
        },

        isPerguntaVisivel(consumo){     
            if(consumo.perguntaPaiId){
                const respostaPerguntaPai = this.model.perguntaUnica[consumo.perguntaPaiId]
                if(respostaPerguntaPai === 'Sim'){
                    return true
                }else{
                    this.model.perguntaUnica[consumo.id] = null 
                    return false
                }
            } 
            return true
        },


        handleMarcarRespostas() {

            if (this.questionario.respostasMarcadas) {
                this.questionario.forEach((questionario) => {

                    let respostaMarcada = this.questionario.respostasMarcadas.find(
                        (respostas) => respostas.perguntaId === questionario.id
                    )

                    if (respostaMarcada && respostaMarcada.respostas.length >= 2) {

                        respostaMarcada.respostas.forEach((resposta) => {
                            this.model.perguntaMultipla.push(resposta)
                        })
                    }

                    if (respostaMarcada && !this.model.perguntaUnica[respostaMarcada.perguntaId]) {
                        respostaMarcada.respostas.forEach((resposta) => this.$set(
                            this.model.perguntaUnica,
                            respostaMarcada.perguntaId,
                            resposta
                        ))
                    }
                });
            }
        }
    },
    computed: {

        geral() {

            return this.questionario.filter(area => area.areaOntemConsumiu == false)
        },
        area() {
            return this.questionario.filter(area => area.areaOntemConsumiu == true)
        },
        validations() {
            return {
                perguntaUnica: {
                    required: this.localRequired
                },
                perguntaMultipla: {
                    required: this.localRequired
                }
            }
        }
    },
    mounted() {
        this.handleMarcarRespostas()
        this.$nextTick().then(() => this.localRequired = this.required)
    },
    watch: {
        'model.perguntaMultipla'() {
                this.localRequired = true
        },
        'model.perguntaUnica'() {
                this.localRequired = true
        },
    }
})

</script>

<style scoped>
.no-margin-top {
    margin-top: 0!important;
}
</style>

